import { motion, AnimatePresence } from 'framer-motion'
import { useState, useEffect } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'

const AnnoncesCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  // Données des annonces (seulement les images)
  const annonces = [
    {
      id: 1,
      image: "/images/WhatsApp Image 2025-10-16 à 14.32.59_dc877864.jpg"
    },
    {
      id: 2,
      image: "/images/WhatsApp Image 2025-10-16 à 14.32.59_d7facb53.jpg"
    },
    {
      id: 3,
      image: "/images/WhatsApp Image 2025-10-16 à 14.32.59_465d5293.jpg"
    },
    {
      id: 4,
      image: "/images/WhatsApp Image 2025-10-16 à 14.32.59_93a9f459.jpg"
    },
    {
       id: 5,
      image: "/images/WhatsApp Image 2025-10-16 à 14.32.59_1d672761.jpg"
    },
    {
       id: 6,
      image: "/images/WhatsApp Image 2025-10-16 à 14.33.00_45fb3d78.jpg"
    },
    {
       id: 7,
      image: "/images/WhatsApp Image 2025-10-16 à 14.33.00_8dbe65b0.jpg"
    }
  ]

  // Changement automatique toutes les 5 secondes
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === annonces.length - 1 ? 0 : prevIndex + 1
      )
    }, 5000) // 5 secondes

    return () => clearInterval(interval)
  }, [annonces.length])

  const nextSlide = () => {
    setCurrentIndex(currentIndex === annonces.length - 1 ? 0 : currentIndex + 1)
  }

  const prevSlide = () => {
    setCurrentIndex(currentIndex === 0 ? annonces.length - 1 : currentIndex - 1)
  }

  const goToSlide = (index) => {
    setCurrentIndex(index)
  }

  return (
    <section className="py-12 bg-gray-50">
      <div className="container-custom">
        <div className="relative h-96 rounded-2xl overflow-hidden shadow-xl">
          {/* Conteneur des slides - SEULEMENT LES IMAGES */}
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, scale: 1.1 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.8 }}
              className="absolute inset-0"
            >
              <div className="relative h-full w-full">
                {/* Image seulement */}
                <img
                  src={annonces[currentIndex].image}
                  alt={`Annonce ${currentIndex + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Boutons de navigation */}
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white/20 hover:bg-white/40 rounded-full flex items-center justify-center transition-all duration-300 group"
          >
            <ChevronLeft className="w-6 h-6 text-white group-hover:scale-110 transition-transform" />
          </button>
          
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white/20 hover:bg-white/40 rounded-full flex items-center justify-center transition-all duration-300 group"
          >
            <ChevronRight className="w-6 h-6 text-white group-hover:scale-110 transition-transform" />
          </button>

          {/* Indicateurs de slide */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {annonces.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex 
                    ? 'bg-white w-8' 
                    : 'bg-white/50 hover:bg-white/70'
                }`}
              />
            ))}
          </div>

          {/* Timer bar */}
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/20">
            <motion.div
              key={currentIndex}
              className="h-full bg-primary"
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 5, ease: "linear" }}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default AnnoncesCarousel